exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.md-help-outline[data-v-0ff843c0] {\n  color: #ff6611;\n}\n.fa[data-v-0ff843c0] {\n  font-size: 18px;\n}\n.fa.pearl-blue[data-v-0ff843c0] {\n  color: #3f51b5;\n}\n.fa.pearl-red[data-v-0ff843c0] {\n  color: #b53f51;\n}\n", ""]);

